<template>
  <ion-app>
    <router-view />
  </ion-app>
</template>

<script>
import { IonApp } from "@ionic/vue";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

export default {
  name: "App",
  components: {
    IonApp,
  },
  async mounted() {
    await SplashScreen.show({
      showDuration: 2000,
      autoHide: true,
    });
    if (Capacitor.getPlatform() === "ios") {
      setTimeout(async () => {
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.setBackgroundColor({ color: "#ffffff" });
        await StatusBar.setStyle({ style: Style.Light });
      }, 2000);
    }
  },
};
</script>
